import { createApp, defineComponent } from 'vue'
import { TogglePassword } from "../mixins"
import { useFlash } from '@/utils/composables'

const App = defineComponent({
    compilerOptions: {
        delimiters: ['[[', ']]']
    },
    mixins: [TogglePassword],
    setup() {
        return {
            ...useFlash(),
        }
    }
})
createApp(App).mount('#app')
